module.exports = __webpack_public_path__ + "static/Egg-d3e4291dab78a06fb3292ec5c986ea7a.png";